import React, { createContext, useCallback, useContext, useState } from 'react'

type FilterEntry = {
  displayName: string // e.g. "Department"
  valueMap: Record<string, string> // e.g. { trd1: "Engineering", trd2: "IT" }
}

interface FilterLabelsState {
  filters: Record<string, FilterEntry>
  registerFilter: (
    param: string,
    displayName: string,
    valueMap: Record<string, string>,
  ) => void
}

const FilterLabelsContext = createContext<FilterLabelsState>({
  filters: {},
  registerFilter: () => undefined,
})

export const useFilterLabels = (): FilterLabelsState =>
  useContext(FilterLabelsContext)

export const FilterLabelsProvider = ({
  children,
}: React.PropsWithChildren): JSX.Element => {
  const [filters, setFilters] = useState<Record<string, FilterEntry>>({})

  const registerFilter = useCallback(
    (param: string, displayName: string, valueMap: Record<string, string>) => {
      setFilters((prev) => {
        const existing = prev[param]
        if (
          existing &&
          existing.displayName === displayName &&
          Object.keys(existing.valueMap).length ===
            Object.keys(valueMap).length &&
          Object.entries(valueMap).every(([k, v]) => existing.valueMap[k] === v)
        ) {
          return prev
        }
        return { ...prev, [param]: { displayName, valueMap } }
      })
    },
    [],
  )

  return (
    <FilterLabelsContext.Provider value={{ filters, registerFilter }}>
      {children}
    </FilterLabelsContext.Provider>
  )
}
